'use client';

import Link from 'next/link';
import React, { FC, useEffect, useState } from 'react';
import { BsBoxSeam } from 'react-icons/bs';

import { Button } from '@mantine/core';

import { User } from 'models';
import { MarketingHelpers } from 'helpers/MarketingHelpers';

import { JoinAsProButton } from 'components/header/components/JoinAsProButton';
import { LoginButton } from 'components/header/components/LoginButton';
import { StartForFreeButton } from 'components/header/components/StartForFreeButton';
import { useHeaderState } from 'components/header/hooks/use-header-state';
import { UserService } from 'services/UserService';

const StaticHeaderActions: FC = () => {
    const [loaded, setLoaded] = useState(false);
    const [localUser, setLocalUser] = useState<User | null>(null);

    useEffect(() => {
        const get = async () => {
            const user = await UserService.getCurrentUser();

            if (user) {
                setLocalUser(user);
            }
        };

        get()
            .then()
            .finally(() => {
                setLoaded(true);
            });
    }, []);

    const { showControllerButtons, showResourceProNav } = useHeaderState();

    if (showResourceProNav) {
        return (
            <>
                {loaded && !localUser && <LoginButton linkable />}
                <JoinAsProButton />
            </>
        );
    }

    if (showControllerButtons) {
        return <ControllerButtons />;
    }

    return loaded ? (
        localUser ? (
            <>
                <Button component={Link} href="/">
                    Dashboard
                </Button>
            </>
        ) : (
            <>
                <Button
                    component={Link}
                    href={MarketingHelpers.urls.dcide.pricing()}
                    variant="transparent"
                    visibleFrom="xs"
                >
                    Discover Pricing
                </Button>

                <StartForFreeButton linkable />
            </>
        )
    ) : null;
};

const ControllerButtons = () => (
    <>
        <Button
            component={Link}
            href={MarketingHelpers.urls.controller.pricing()}
            variant="transparent"
            data-type="controller"
            visibleFrom="xs"
        >
            Discover Pricing
        </Button>
        <Button component={Link} href={MarketingHelpers.urls.controller.starterKit()} leftSection={<BsBoxSeam />}>
            Get Starter Kit
        </Button>
    </>
);
export { StaticHeaderActions };
